import React from "react";

export default function Footer() {
  return (
    <footer className="bg-transparent">
      <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
        <p className="mt-8 text-center text-base text-gray-400 dark:text-gray-500">
          &copy; {new Date().getFullYear()} CetaPOS. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
